import {Box, Tab, TabGroup, Text} from "@nike/eds";
import React from "react";
import {DSLeftCW} from "../DirectShipmentLeftCustomsWarehouse/DSLeftCW";
import {edsSpace16} from "@nike/eds/dist/tokens";
import DivertFromUk from "../divertFromUk/DivertFromUK";
import BondedReturn from "../bondedReturn/BondedReturn";
import {ManualClearing} from "../manual-clearing/ManualClearing";

export function Overview({dSLeftCWService, manualClearingService, permissions}) {

    const titleStyle = {
        marginBottom: edsSpace16
    }

    const getDefaultTabId = () => {
        if (permissions.canTriggerDSLeftCW) {
            return "DirectShipmentLeftCustomsWarehouseTab";
        }
        if (permissions.canTriggerUKDivert) {
            return "DivertFromUk";
        }
        if (permissions.canTriggerBondedReturn) {
            return "BondedReturnTab";
        }
        if (permissions.canTriggerManualClearing) {
            return "ManualClearingTab";
        }
    };

    const defaultTabId = getDefaultTabId();
    const [activeId, setActiveId] = React.useState(defaultTabId);

    return (
        <div>
            <Text style={titleStyle} font={"display-3"} as={"h3"}>TRIGGER</Text>


            <Box>
                <div>
                    <TabGroup
                        className="eds-spacing--pb-16"
                        name="tab-group-trigger"
                        onChange={e => setActiveId(e.target.id)}
                        defaultId={defaultTabId}
                        activeId={activeId}
                    >
                        {permissions.canTriggerDSLeftCW &&
                            <Tab id="DirectShipmentLeftCustomsWarehouseTab">DirectShipmentLeftCustomsWarehouse</Tab>
                        }
                        {permissions.canTriggerUKDivert &&
                            <Tab id="DivertFromUk">Divert from UK</Tab>}
                        {permissions.canTriggerBondedReturn &&
                            <Tab id="BondedReturnTab">Bonded return</Tab>}
                        {permissions.canTriggerManualClearing &&
                            <Tab id="ManualClearingTab">Manual Clearing</Tab>}
                    </TabGroup>

                    {permissions.canTriggerDSLeftCW &&
                        <div hidden={activeId !== 'DirectShipmentLeftCustomsWarehouseTab'}>
                            <DSLeftCW dSLeftCWService={dSLeftCWService}/>
                        </div>
                    }
                    {permissions.canTriggerUKDivert &&
                        <div hidden={activeId !== 'DivertFromUk'}>
                            <DivertFromUk/>
                        </div>
                    }
                    {permissions.canTriggerBondedReturn &&
                        <div hidden={activeId !== 'BondedReturnTab'}>
                            <BondedReturn/>
                        </div>
                    }
                    {permissions.canTriggerManualClearing &&
                        <div hidden={activeId !== 'ManualClearingTab'}>
                            <ManualClearing manualClearingService={manualClearingService}/>
                        </div>
                    }
                </div>
            </Box>
        </div>
    )
}
